import queryString from 'query-string';
import { FILEEE_DOMAINS, getBaseDomainUrl, isProductionEnv } from './utils';

/* for both query params and hash params */
export function getSearchParams() {
  return queryString.parse(window.location.search) || {};
}

export function getSearchOnlyParams() {
  return queryString.parse(window.location.search) || {};
}

export function getBaseReloadLocation() {
  return '';
}

export function getLocationPathName() {
  return window.location.pathname;
}

export function getHostName() {
  return window.location.hostname;
}

/**
 * Exported only for testing
 * @param {string} shareId
 * @returns {string | null}
 */
export function getLinkFromShareId(shareId) {
  if (shareId) {
    const currentDomain = getBaseDomainUrl();
    if (FILEEE_DOMAINS.has(currentDomain)) {
      return `${currentDomain}/shared/${shareId}`;
    } else {
      return `https://my.fileee.com/shared/${shareId}`;
    }
  } else {
    return null;
  }
}

export function getSupportActionLink() {
  if (isProductionEnv()) {
    // https://file.ee/serviceanfrage
    return '/actions/50ac222b0cf2f924c9ccb919-5ef1fbebe8dd85567073794d';
  } else {
    return '/actions/50ac222b0cf2f924c9ccb919-5ef1fbebe8dd85567073794d';
  }
}

export function getBaseRelativeUrl() {
  return '/';
}

/**
 *
 * @param {string} link Relative Link
 */
export function fullPageRedirectTo(link) {
  window.location.href = `${getBaseReloadLocation()}${link}`;
}
